<script setup lang="ts">
import { ref, onMounted } from 'vue';

const showDialog = ref(false);
const STORAGE_KEY = 'yoga-update-shown';
const VALID_UNTIL = '2024-06-30'; // Show until end of June 2024

onMounted(() => {
  const updateShown = localStorage.getItem(STORAGE_KEY);
  if (!updateShown && new Date() <= new Date(VALID_UNTIL)) {
    showDialog.value = true;
  }
});

function handleClose() {
  showDialog.value = false;
  localStorage.setItem(STORAGE_KEY, 'true');
}
</script>

<template>
  <div v-if="showDialog" class="modal-overlay" @click="handleClose">
    <div class="modal-content" @click.stop>
      <h3>Update</h3>
      <div class="update-text">
        <p>Kurse werden vollständig angezeigt</p>
        <p>Markierte Kurse sollten jetzt nicht wieder verschwinden</p>
      </div>
      <button @click="handleClose">Ok</button>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  max-width: 90%;
  width: 400px;
  text-align: center;
}

h3 {
  color: #960040;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.update-text {
  color: #000;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

button {
  background: #960040;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
}

button:hover {
  background: #7d0035;
}
</style>